import { useEffect, useState } from 'react';
import { customerApi } from '@/lib/api';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Bell } from 'lucide-react';

const TYPE_ICON_COLOR = {
  LOW_BALANCE: 'text-amber-600',
  SUBSCRIPTION_ACTIVATED: 'text-coriander',
  REDEMPTION: 'text-saffron',
  PROMOTIONAL: 'text-coriander',
  TOPUP: 'text-coriander',
  BONUS: 'text-coriander',
  ADDON: 'text-coriander',
};

export function NotificationBell() {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [open, setOpen] = useState(false);

  const load = () => customerApi.get('/notifications/me').then(({ data }) => {
    setNotifications(data.notifications);
    setUnreadCount(data.unreadCount);
  });

  useEffect(() => {
    load();
  }, []);

  const onOpenChange = async (next) => {
    setOpen(next);
    if (next && unreadCount > 0) {
      await customerApi.post('/notifications/read-all');
      setUnreadCount(0);
      setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
    }
  };

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell-btn" className="relative h-10 w-10 rounded-full bg-white flex items-center justify-center border border-black/5">
          <Bell size={18} className="text-charcoal" />
          {unreadCount > 0 && (
            <span
              data-testid="notification-unread-badge"
              className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-saffron text-white text-[10px] font-bold flex items-center justify-center"
            >
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0 max-h-96 overflow-y-auto" data-testid="notification-panel">
        <div className="p-3 border-b border-border/30">
          <p className="font-heading font-semibold text-charcoal text-sm">Notifications</p>
        </div>
        {notifications.length === 0 && <p className="p-6 text-sm text-muted-ink text-center">You're all caught up.</p>}
        {notifications.map((n) => (
          <div key={n.id} data-testid="notification-item" className="p-3 border-b border-border/20 last:border-0">
            <p className={`text-sm font-medium ${TYPE_ICON_COLOR[n.type] || 'text-charcoal'}`}>{n.title}</p>
            <p className="text-xs text-muted-ink mt-0.5">{n.message}</p>
            <p className="text-[10px] text-muted-ink/60 mt-1">
              {new Date(n.createdAt).toLocaleString('en-CA', { timeZone: 'America/Edmonton', dateStyle: 'medium', timeStyle: 'short' })}
            </p>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
